import { PATH_HELPERS } from '../../../constants/navigation'

// Components
import Panel from '../Panel'
import { AppreciationSentence } from './AppreciationSentence'
import Chart from './Chart'
import { EstimatedValueZeroState } from './EstimatedValueZeroState'
import { NetWorthPreview } from './NetWorthSection'

// Styles
import styles from './EstimatedValue.module.scss'

// selectors
import { useSelector } from 'react-redux'
import { selectCustomerProfile } from '../../../store/selectors/customerProfile'
import { selectClientId } from '../../../store/selectors/client'
import { selectHomeId } from '../../../store/selectors/home'

import { selectCurrentAVMMap } from '../../../store/selectors/homePreview'

// hooks
import { useLocation } from 'react-router'

// types
import { RootState } from '../../../store'
import { EstimatedValuePanelHeading } from './EstimatedValuePanelHeading'
import { EstimatedValueCurrencyDisplay } from './EstimatedValueCurrencyDisplay'
import { CurrentAVMMap } from '../../../types/avm'

// etc
import * as Sentry from '@sentry/browser'

interface EstimatedValuePreviewProps {
  disableValue: boolean
}

export const EstimatedValuePreview = ({
  disableValue,
}: EstimatedValuePreviewProps) => {
  const customerProfile = useSelector(selectCustomerProfile) || {}

  const legacyHomeId = useSelector<RootState, string>(selectHomeId)
  const clientId = useSelector<RootState, string>(selectClientId)

  const activePath =
    !!legacyHomeId &&
    !!clientId &&
    PATH_HELPERS.home.buildPath(clientId, legacyHomeId) + window.location.search

  const location = useLocation()
  const searchParams = new URLSearchParams(location.search)
  const addressId = searchParams.get('id')

  const avmMap = useSelector<RootState, CurrentAVMMap>(selectCurrentAVMMap)
  if (!addressId) {
    Sentry.captureMessage(
      'Failed to parse address id (fips and apn) from URL in Homeowner Preview'
    )
    return null
  }
  const avm = avmMap[addressId]
  const homeValue = avm?.amount

  if (!homeValue) {
    return <EstimatedValueZeroState customerProfile={customerProfile} />
  }

  return (
    <Panel data-qa='EstimatedValueCard' className={styles.container}>
      <EstimatedValuePanelHeading homeValue={homeValue} />
      <section className={styles.section}>
        <div className={styles.avm}>
          <EstimatedValueCurrencyDisplay
            homeValue={homeValue}
            shouldBlur={false}
          />
        </div>
        <Chart clipPath={activePath} />
        <AppreciationSentence
          className={styles.appreciationText}
          withCurrentHomeData={false}
        />
      </section>

      <NetWorthPreview />
    </Panel>
  )
}
